import React, { memo } from 'react'
import { CLAN_SUPPLY_QUESTS_TITLE, CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS } from '../translations'
import styles from './cards.scss'
import classNames from 'classnames'
import ArcProgressbarQuest from './ArcProgressbar/ArcProgressbarQuest'
import ProgressbarTooltip from './ClanSupplyTooltips/ProgressbarTooltip'
import ClanSupplyFooterQuests from './ClanSupplyFooter/ClanSupplyFooterQuests'
import ClanSupplyQuestsTimer from './ClanSupplyQuestsTimer/ClanSupplyQuestsTimer'
import { selectQuests } from '../selectors'
import { useSelector } from 'react-redux'
import { QUEST_STATUSES } from './clan_quests_constants'
import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap/lib/helpers/web_to_client'
import { openClanSupplyQuests } from '../../../helpers/web_to_client'
import QuestStatusTooltip from './ClanSupplyTooltips/QuestStatusTooltip'
import { thousands } from '@wotfe/formatters'

const tooltipQuestId = 'tooltipId-clan-supply-quest-card-'

const ClanSupplyQuestsCard = memo(() => {
    const quests = useSelector(selectQuests)
    const previousRewardsSum = quests.previousRewards.tourCoin + quests.previousRewards.industrialResource
    const availableQuestIndex = quests.questsList.findIndex(quest => quest.status === QUEST_STATUSES.INCOMPLETE)
    const isLockedByPreviousCycle = availableQuestIndex === 0 && previousRewardsSum > 0

    const handleCardClick = event => {
        event.stopPropagation()

        openClanSupplyQuests()
    }

    const availableRewards = quests.questsList.reduce(
        (acc, quest) => {
            if (quest.status === QUEST_STATUSES.REWARD_AVAILABLE) {
                acc.tourCoin += quest.rewards.tourCoin
                acc.industrialResource += quest.rewards.industrialResource
            }

            return acc
        },
        {
            tourCoin: 0,
            industrialResource: 0,
        },
    )

    return (
        <div
            className={classNames(styles.card, styles.clanSupplyQuestsCard)}
            onClick={handleCardClick}
            onMouseDown={sendClickSoundCommand}
            onMouseEnter={sendHoverSoundCommand}
        >
            <h2>{CLAN_SUPPLY_QUESTS_TITLE}</h2>

            <div className={styles.timer}>
                <ClanSupplyQuestsTimer
                    cycleEnd={quests.cycleEnd}
                />
            </div>

            <div className={styles.quests}>
                {quests.questsList.map((item, index) => {
                    const tooltipQuestProgressBarId = tooltipQuestId + 'progressbar-' + index
                    const tooltipQuestStatusId = tooltipQuestId + 'status-' + index
                    const isAvailable = index === availableQuestIndex && !isLockedByPreviousCycle

                    return (
                        <div
                            className={styles.quest}
                            key={item.name}
                        >
                            <div
                                data-tip
                                data-for={tooltipQuestProgressBarId}
                            >
                                <ArcProgressbarQuest
                                    level={item.level}
                                    currentProgress={item.currentProgress}
                                    requiredProgress={item.requiredProgress}
                                    status={item.status}
                                    isAvailable={isAvailable}
                                />
                                <ProgressbarTooltip
                                    id={tooltipQuestProgressBarId}
                                    rule={item.conditions.main.rule.type}
                                    value={item.conditions.main.rule.value}
                                    squadStates={item.conditions.main.squadStates}
                                    isClanSquad={item.conditions.main.isClanSquad}
                                    levelFrom={item.conditions.common.levelFrom}
                                    levelTo={item.conditions.common.levelTo}
                                    status={item.status}
                                    industrialResource={item.rewards.industrialResource}
                                    tourCoin={item.rewards.tourCoin}
                                />
                            </div>
                            <div
                                className={styles.status}
                                data-tip
                                data-for={tooltipQuestStatusId}
                            >
                                {isAvailable ?
                                    <div className={styles.progress}>
                                        {CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS(
                                            <span className={classNames(
                                                styles.current,
                                                item.currentProgress > 0 && styles.current__started,
                                            )}
                                            >{item.currentProgress}</span>,
                                            <span className={styles.required}>{item.requiredProgress}</span>,
                                        )}
                                    </div> :
                                    <div
                                        className={classNames(
                                            styles['icon-status'],
                                            item.status ===
                                            QUEST_STATUSES.REWARD_PENDING && styles['icon-status__pending'],
                                            item.status ===
                                            QUEST_STATUSES.REWARD_AVAILABLE && styles['icon-status__reward-available'],
                                            item.status ===
                                            QUEST_STATUSES.COMPLETE && styles['icon-status__complete'],
                                        )}
                                    />
                                }
                                <QuestStatusTooltip
                                    id={tooltipQuestStatusId}
                                    isAvailable={isAvailable}
                                    previousRewardsSum={previousRewardsSum}
                                    isLockedByPreviousCycle={isLockedByPreviousCycle}
                                    status={item.status}
                                />
                            </div>
                        </div>
                    )
                })}
            </div>

            <p className={styles.rewards}>
                {(quests.previousRewards.tourCoin > 0 || availableRewards.tourCoin > 0) && (
                    <span className={classNames(styles.currencies, styles['currencies__tourCoin'])}>
                        {thousands(quests.previousRewards.tourCoin + availableRewards.tourCoin)}
                    </span>
                )}
                {(quests.previousRewards.industrialResource > 0 || availableRewards.industrialResource > 0) && (
                    <span className={classNames(styles.currencies, styles['currencies__industrialResource'])}>
                        {thousands(quests.previousRewards.industrialResource + availableRewards.industrialResource)}
                    </span>
                )}
            </p>

            <ClanSupplyFooterQuests
                questsList={quests.questsList}
                previousRewardsSum={previousRewardsSum}
            />
        </div>
    )
})

export default ClanSupplyQuestsCard



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanSupplyQuestsCard.jsx